import { render, staticRenderFns } from "./OrganizationEmbed.vue?vue&type=template&id=aee756e4&"
import script from "./OrganizationEmbed.vue?vue&type=script&lang=js&"
export * from "./OrganizationEmbed.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationEmbed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports